/*==================================================
 *  Common localization strings
 *==================================================
 */

Timeline.strings["it"] = {
    wikiLinkLabel:  "Discuti"
};




//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/scripts/l10n/it/timeline.js
// module id = 581
// module chunks = 3